import React from 'react';
import * as PropTypes from 'prop-types';
import styles from '../DerouleArmeComponent.module.scss';

const DerouleArmeCanonComponent = ({ canon }) => (
    <div className={styles['DerouleArme-element']}>
        <div className={styles['DerouleArme-labelElement']}>
            Canon
            {canon.numeroCanon}
        </div>
        {canon.numeroSerie && (
            <div>
                Numéro de série :{' '}
                <span className={styles['DerouleArme-labelElement']}>{canon.numeroSerie}</span>
            </div>
        )}
        {canon.numeroEncodage && (
            <div>
                Numéro d&apos;encodage :{' '}
                <span className={styles['DerouleArme-labelElement']}>{canon.numeroEncodage}</span>
            </div>
        )}
        {canon.rgaCanon && (
            <>
                <div>
                    Calibre :{' '}
                    <span className={styles['DerouleArme-labelElement']}>
                        {canon.rgaCanon.libelleCalibre}
                    </span>
                </div>
                <div>
                    Mode de percussion :{' '}
                    <span className={styles['DerouleArme-labelElement']}>
                        {canon.rgaCanon.percussion}
                    </span>
                </div>
                <div>
                    Type de canon :{' '}
                    <span className={styles['DerouleArme-labelElement']}>
                        {canon.rgaCanon.typeCanon}
                    </span>
                </div>
                <div>
                    Longueur canon :{' '}
                    <span className={styles['DerouleArme-labelElement']}>
                        {canon.rgaCanon.longueur}
                    </span>
                </div>
            </>
        )}
    </div>
);

DerouleArmeCanonComponent.defaultProps = {
    canon: null,
};

DerouleArmeCanonComponent.propTypes = {
    canon: PropTypes.shape({
        numeroCanon: PropTypes.number.isRequired,
        numeroSerie: PropTypes.string,
        numeroEncodage: PropTypes.string,
        rgaCanon: PropTypes.shape({
            libelleCalibre: PropTypes.string.isRequired,
            longueur: PropTypes.string.isRequired,
            percussion: PropTypes.string.isRequired,
            typeCanon: PropTypes.string.isRequired,
        }),
    }),
};

export default DerouleArmeCanonComponent;
